/**
 * モンスター画像テクスチャキー
 */
export const MonsterImageKey = {
  // バトルスプライト (100x100)
  ZAAG_BATTLE: 'monster_zaag_battle',
  GARDAN_BATTLE: 'monster_gardan_battle',
  ROONA_BATTLE: 'monster_roona_battle',
  ZEPHYR_BATTLE: 'monster_zephyr_battle',
  BALGA_BATTLE: 'monster_balga_battle',
  MORSU_BATTLE: 'monster_morsu_battle',
  GRAON_BATTLE: 'monster_graon_battle',
  IGNA_BATTLE: 'monster_igna_battle',

  // ポートレート (60x60)
  ZAAG_PORTRAIT: 'monster_zaag_portrait',
  GARDAN_PORTRAIT: 'monster_gardan_portrait',
  ROONA_PORTRAIT: 'monster_roona_portrait',
  ZEPHYR_PORTRAIT: 'monster_zephyr_portrait',
  BALGA_PORTRAIT: 'monster_balga_portrait',
  MORSU_PORTRAIT: 'monster_morsu_portrait',
  GRAON_PORTRAIT: 'monster_graon_portrait',
  IGNA_PORTRAIT: 'monster_igna_portrait',
} as const;

/**
 * UI画像テクスチャキー
 */
export const UIImageKey = {
  LOCK_ICON: 'ui_lock_icon',
} as const;

/**
 * 背景画像テクスチャキー
 */
export const BackgroundImageKey = {
  TITLE: 'bg_title',
  TITLE_LOGO: 'title_logo',
  BATTLE: 'bg_battle',
  BATTLE_2: 'bg_battle_2',
  BATTLE_3: 'bg_battle_3',
  BATTLE_4: 'bg_battle_4',
  BATTLE_5: 'bg_battle_5',
  BATTLE_6: 'bg_battle_6',
  BATTLE_7: 'bg_battle_7',
  BATTLE_LUNA: 'bg_battle_luna',
  BATTLE_STATE8: 'bg_battle_state8',
  BATTLE_BOSS_1: 'bg_battle_boss_1',
  BATTLE_BOSS_2: 'bg_battle_boss_2',
  BATTLE_ARENA: 'bg_battle_arena',
  BOSS_RESULT: 'boss_result',
  CHARACTER_SELECT: 'bg_character_select',
  MODE_SELECT: 'bg_mode_select',
  RESULT: 'bg_result',
  SETTINGS: 'bg_settings',
} as const;

/**
 * 対戦背景の選択肢（自由対戦・キャラ選択画面で表示）
 */
export const BATTLE_BACKGROUND_OPTIONS: { key: string; label: string }[] = [
  { key: 'bg_battle',       label: '幽炎の闘技場' },
  { key: 'bg_battle_2',     label: '朱暮の廃址' },
  { key: 'bg_battle_3',     label: '業火の祭壇' },
  { key: 'bg_battle_4',     label: '霞峰の遺址' },
  { key: 'bg_battle_5',     label: '氷晶の洞窟' },
  { key: 'bg_battle_6',     label: '月砂の荒野' },
  { key: 'bg_battle_7',     label: '嵐渦の天砦' },
  { key: 'bg_battle_luna',  label: '極光の聖域' },
  { key: 'bg_battle_arena', label: '皇都の闘技場' },
];

/**
 * モンスターIDからバトルテクスチャキーを取得
 */
export function getMonsterBattleKey(monsterId: string): string {
  return `monster_${monsterId}_battle`;
}

/**
 * モンスターIDからポートレートテクスチャキーを取得
 */
export function getMonsterPortraitKey(monsterId: string): string {
  return `monster_${monsterId}_portrait`;
}
